<template>
    
    <div class="taskinfoContainer">
        <HeaderTask />
        <div class="taskinfoContainer2">
            <div class="px-4 sm:px-0">
                <h3 class="text-base font-semibold leading-7 text-gray-900">{{ data.title }}</h3>
            </div>
            <div class="mt-6 border-t border-gray-100">
                <dl class="divide-y divide-gray-100">
                    <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt class="text-sm font-medium leading-6 text-gray-900">Estado</dt>
                        <dd class="containerStatusTaskInfo mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                            <div class="containerStatus ajustarContainer" :style="getStatusStyle(data.status)">
                                {{ data.status }}
                            </div>
                            <div>
                                <Menu as="div" class="relative inline-block text-left">
                                    <div>
                                        <MenuButton
                                            class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">

                                            <ChevronDownIcon class="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                                        </MenuButton>
                                    </div>
                                    <transition enter-active-class="transition ease-out duration-100"
                                        enter-from-class="transform opacity-0 scale-95"
                                        enter-to-class="transform opacity-100 scale-100"
                                        leave-active-class="transition ease-in duration-75"
                                        leave-from-class="transform opacity-100 scale-100"
                                        leave-to-class="transform opacity-0 scale-95">
                                        <MenuItems
                                            class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            <div class="py-1">
                                                &nbsp; Cambiar Estado
                                                <form method="POST" action="#">
                                                    <MenuItem v-slot="{ active }">
                                                    <button type="submit"
                                                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full px-4 py-2 text-left text-sm']">Pendiente</button>
                                                    </MenuItem>
                                                </form>
                                                <form method="POST" action="#">
                                                    <MenuItem v-slot="{ active }">
                                                    <button type="submit"
                                                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full px-4 py-2 text-left text-sm']">En
                                                        proceso</button>
                                                    </MenuItem>
                                                </form>
                                                <form method="POST" action="#">
                                                    <MenuItem v-slot="{ active }">
                                                    <button type="submit"
                                                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full px-4 py-2 text-left text-sm']">Completado</button>
                                                    </MenuItem>
                                                </form>
                                                <form method="POST" action="#">
                                                    <MenuItem v-slot="{ active }">
                                                    <button type="submit"
                                                        :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full px-4 py-2 text-left text-sm']">Bloqueado</button>
                                                    </MenuItem>
                                                </form>
                                            </div>
                                        </MenuItems>
                                    </transition>
                                </Menu>
                            </div>
                        </dd>
                    </div>
                    <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt class="text-sm font-medium leading-6 text-gray-900">Descripción</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{{ data.description }}</dd>
                    </div>
                    <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt class="text-sm font-medium leading-6 text-gray-900">Cantidad de comentarios</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">5
                        </dd>
                    </div>
                    <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt class="text-sm font-medium leading-6 text-gray-900">Cantidad de archivos adjuntos</dt>
                        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">2</dd>
                    </div>
                    <div class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                        <dt class="text-sm font-medium leading-6 text-gray-900">Archivos Adjuntos</dt>
                        <dd class="mt-2 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                            <ul role="list" class="divide-y divide-gray-100 rounded-md border border-gray-200">
                                <li class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
                                    <div class="flex w-0 flex-1 items-center">
                                        <PaperClipIcon class="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                        <div class="ml-4 flex min-w-0 flex-1 gap-2">
                                            <span class="truncate font-medium">resume_back_end_developer.pdf</span>
                                            <span class="flex-shrink-0 text-gray-400">2.4mb</span>
                                        </div>
                                    </div>
                                    <div class="ml-4 flex-shrink-0">
                                        <a href="#"
                                            class="font-medium text-indigo-600 hover:text-indigo-500">Download</a>
                                    </div>
                                </li>
                                <li class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
                                    <div class="flex w-0 flex-1 items-center">
                                        <PaperClipIcon class="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                        <div class="ml-4 flex min-w-0 flex-1 gap-2">
                                            <span class="truncate font-medium">coverletter_back_end_developer.pdf</span>
                                            <span class="flex-shrink-0 text-gray-400">4.5mb</span>
                                        </div>
                                    </div>
                                    <div class="ml-4 flex-shrink-0">
                                        <a href="#"
                                            class="font-medium text-indigo-600 hover:text-indigo-500">Download</a>
                                    </div>
                                </li>
                            </ul>
                        </dd>
                    </div>
                </dl>
            </div>
        </div>
    </div>

</template>
<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import HeaderTask from '../Layaout/HeaderTask.vue';
</script>

<script>
export default {
    data() {
        return {
            data: '',
            descripcion: '',
            taskId: null,
            items: [
                { status: 'En proceso' },
                { status: 'Pendiente' },
                { status: 'Completado' },
                { status: 'Bloqueado' }
            ]
        };
    },
    methods: {
        getStatusStyle(status) {
            switch (status) {
                case 'En proceso':
                    return { backgroundColor: 'yellow' };
                case 'Pendiente':
                    return { backgroundColor: 'orange' };
                case 'Completado':
                    return { backgroundColor: 'lightgreen' };
                case 'Bloqueado':
                    return { backgroundColor: 'red' };
                default:
                    return { backgroundColor: 'white' }; // Color por defecto si el estado no coincide con ninguno de los anteriores
            }
        }
    },
    async created() {
        let taskId = this.$route.params.id;
        try {
            //el id debe ser variable segun se reciba por url
            const response = await fetch(`http://127.0.0.1:8000/api/tasks/${taskId}`);
            const data = await response.json();
            this.data = data;
            console.log(data);
        } catch (error) {
            console.error('Error al obtener datos:', error);
        }
    }
};


</script>